module.exports = __webpack_public_path__ + "static/media/cardgoddess.d2fc0e21.jpg";